import { default as _axios } from 'axios'
import { getToken } from './useToken';

const axios = _axios.create();
axios.interceptors.request.use(
  config => {
    const token = getToken();
    if (token) {
      config.headers["Authorization"] = token;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

export default axios